// extracted by mini-css-extract-plugin
export default {"schedulePanels":"SchedulePanels-module__schedulePanels___Lxs3x"};